/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type HomePendingFeedbackOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['ID']['input'];
}>;

export type HomePendingFeedbackOrderQuery = {
  readonly __typename?: 'Query';
  readonly orderStatus:
    | { readonly __typename: 'InvalidOrder' }
    | {
        readonly __typename: 'OrderStatus';
        readonly flattenedOrderStatus: Types.FlattenedOrderStatuses;
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly isPendingFeedback: boolean;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
            };
          }>;
        };
      }
    | null;
};

export const HomePendingFeedbackOrderDocument = gql`
  query HomePendingFeedbackOrder($orderId: ID!) {
    orderStatus(orderId: $orderId) {
      __typename
      ... on OrderStatus {
        flattenedOrderStatus
        order {
          id
          __typename
          wantedTime
          isPendingFeedback
          lineItems {
            id
            __typename
            product {
              id
              __typename
              asset {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export function useHomePendingFeedbackOrderQuery(
  options: Omit<Urql.UseQueryArgs<HomePendingFeedbackOrderQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HomePendingFeedbackOrderQuery, HomePendingFeedbackOrderQueryVariables>({
    query: HomePendingFeedbackOrderDocument,
    ...options,
  });
}
